module.exports = __webpack_public_path__ + "img/bg2.f01dfbb0.jpg";